"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.errorPageTranslations = void 0;
var translations = _interopRequireWildcard(require("./translations"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const errorPageTranslations = exports.errorPageTranslations = {
  az: translations.azerbadjanTranslations,
  be: translations.belarusTranslations,
  bg: translations.BulgariaTranslations,
  bs: translations.bosniaTranslations,
  cs: translations.czechRepublicTranslations,
  da: translations.denmarkTranslations,
  de: translations.germanTranslations,
  el: translations.greeceTranslations,
  en: translations.englishTranslations,
  es: translations.latinAmericaTranslations,
  et: translations.estoniaTranslations,
  fi: translations.finlandTranslations,
  fr: translations.algeriaTranslations,
  hr: translations.croatiaTranslations,
  hu: translations.hungaryTranslations,
  hy: translations.armeniaTranslations,
  id: translations.indonesiaTranslations,
  ka: translations.georgiaTranslations,
  kk: translations.kazakhstanTranslations,
  ky: translations.kyrgystanTranslations,
  lt: translations.lithuaniaTranslations,
  lv: translations.latviaTranslations,
  mk: translations.macedoniaTranslations,
  mn: translations.mongoliaTranslations,
  my: translations.myanmarTranslations,
  nb: translations.norwayTranslations,
  nl: translations.hollandTranslations,
  pl: translations.polandTranslations,
  pt: translations.portugalTranslations,
  ro: translations.romaniaTranslations,
  ru: translations.cisTranslations,
  si: translations.sloveniaTranslations,
  sk: translations.slovakiaTranslations,
  sr: translations.serbiaTranslations,
  sv: translations.swedenTranslations,
  th: translations.thailandTranslations,
  tr: translations.turkeyTranslations,
  uk: translations.ukraineTranslations,
  vi: translations.vietnamTranslations,
  zh: translations.chinaTranslations
};
